// Odd imports to keep filesize down without tree shaking
import { Observable, fromEvent } from 'rxjs';
import { filter, map, takeWhile } from 'rxjs/operators';

// The sandbox types library has a lot of boundary issues that are bubbling up here.
// If we resolve those, we can remove this.
// eslint-disable-next-line @nx/enforce-module-boundaries
import { EmitTransport, Messages } from '@mode/reports/sandbox/contract';
import { Broadcaster } from '@mode/shared/util-iframe';

function isEmitMessage(msg: MessageEvent) {
  return msg != null && msg.data != null && msg.data.type !== 'rpcRequest' && msg.data.type !== 'rpcResponse';
}

export const Emit: EmitTransport = {
  getMessageStream: function <T extends Messages>(source: EventTarget): Observable<T> {
    return fromEvent<MessageEvent>(source, 'message').pipe(
      takeWhile(() => source != null),
      filter(isEmitMessage),
      map((msg) => msg.data as T)
    );
  },

  emit: function <T extends Messages>(source: Broadcaster, message: T): void {
    // TODO: Fix origin
    source.postMessage(message, '*');
  },
};
